'use strict';
module.exports = Backbone.Model.extend({
    hashCode: '',
    isLegacy: false,
});
